import { createModel } from '../../../services/api2.service';
import { IContact, IContactReturn } from '../interface';

/**
 * Action to create a new contact
 * @param values data to create contact
 */

export const createContact = async (contact: IContact): Promise<IContactReturn> => {
    const result = await createModel('contact/message')(contact);
    return result;
};
